export default "__VITE_ASSET__DpRpmLT5__"